// One definition of "a link we are willing to put in <a href>" - used by the database rules (lib/d1-rules.ts, on write) AND by the
// UI (app/page.tsx, on render), so a bad value can neither be stored nor clicked even if one of the two layers is bypassed.
// Only plain http(s) links qualify: `javascript:`, `data:`, `vbscript:` ... would run script in the VIEWER's session when tapped.

/** Returns the URL if it is a plain http(s) link of sane length, otherwise ''. */
export function safeHttpUrl(v: unknown): string {
  if (typeof v !== 'string') return ''
  const s = v.trim()
  if (!s || s.length > 500 || /[\u0000-\u001f\u007f\s]/.test(s)) return ''
  return /^https?:\/\/[^\s/$.?#][^\s]*$/i.test(s) ? s : ''
}

/** For stored media / banner image values: https image URL, an inline image, or an app-relative path. */
export function safeMediaUrl(v: unknown): string {
  if (typeof v !== 'string') return ''
  const s = v.trim()
  if (!s || s.length > 200_000 || /[\u0000-\u001f\u007f]/.test(s)) return ''
  if (/^https:\/\/[^\s'"()<>\\]+$/i.test(s) && s.length <= 2000) return s
  if (/^data:image\/(png|jpe?g|webp|gif|avif);base64,[A-Za-z0-9+/=]+$/i.test(s)) return s
  if (/^\/[A-Za-z0-9_./-]*$/.test(s) && !s.startsWith('//')) return s
  return ''
}
